export const Constants = Object.freeze({
    BasePath: process.env.NEXT_PUBLIC_BASE_PATH || ''
});